var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pill shadow"},[_c('n-text',{attrs:{"preset":"sub","color":"accent"}},[_vm._t("default")],2),_c('span',{staticClass:"icon"},[(_vm.arrow)?_c('n-icon',{attrs:{"size":"sm","name":"chevron-right","color":"accent"}}):_vm._e()],1),_c('span',{staticClass:"triangle"},[_vm._v("▼")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }